<template>
  <div class="formbuilder-sidebar-editor">
    <div class="sidebar-editor-wrapper">
      <div class="close" @click="$emit('toggleSettings')"></div>
      <div class="sidebar-header">
        <h2>Element Bearbeiten</h2>
      </div>
      <div class="sidebar-content">
        <div
          v-for="action in actions"
          v-if="isVisible(action.key)"
          class="w-100 d-flex justify-content-between align-items-center pt-2"
          :key="action.key"
        >
          <label class="caption">{{ action.label }}</label>

          <CommonSwitch
            @input="(e) => onTabSettingsChange(e, action.key)"
            class="large-size"
            :value="getSwitchValue(action.key)"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CommonSwitch from '../widgets/CommonSwitch.vue';

export default {
  name: 'TabSettingsModal',
  props: {
    tabStructure: { type: Object, required: true },
  },
  data() {
    return {
      actions: [
        {
          label: 'Als Progressbar anzeigen',
          key: 'showProgressBar',
        },
        {
          label: 'Nummern anzeigen',
          key: 'showNumbers',
        },
        {
          label: 'Tab Bezeichnung anzeigen',
          key: 'showLabel',
        },
      ],
    };
  },
  methods: {
    isVisible(key) {
      if (['showNumbers', 'showLabel'].includes(key)) {
        return this.tabStructure?.layout?.showProgressBar || false;
      }

      return true;
    },
    onTabSettingsChange(e, key) {
      if (key == 'showProgressBar' && !e) {
        this.$set(this.tabStructure, 'layout', {});
      } else {
        this.$set(this.tabStructure.layout, key, e);
      }
    },
    getSwitchValue(key) {
      return this.tabStructure?.layout ? this.tabStructure?.layout[key] : false;
    },
  },
  components: { CommonSwitch },
};
</script>
<style scoped>
.formbuilder-sidebar-editor {
  height: 100%;
  width: 425px;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.formbuilder-sidebar-editor .sidebar-editor-wrapper {
  text-align: left;
  padding: 40px 0;
  border-left: 1px solid #dee3e9;
  border-radius: 0px 19px 19px 0px;
  background: #ffffff;
  display: block;
  text-align: left;
  font-size: 12px;
  line-height: 17px;
  color: #5f697a;
  height: 100%;
  width: 100%;
  position: relative;
}

.formbuilder-sidebar-editor .sidebar-editor-wrapper .close {
  position: absolute;
  top: 32px;
  right: 36px;
  background-image: url(../../assets/img/work-flow-icons/close.svg);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  width: 14px;
  height: 14px;
  cursor: pointer;
}
.formbuilder-sidebar-editor .sidebar-editor-wrapper .close:hover {
  opacity: 0.8;
}

.formbuilder-sidebar-editor .sidebar-header {
  padding: 20px 40px;
}

.formbuilder-sidebar-editor .sidebar-content {
  height: calc(100dvh - 245px);
  overflow: auto;
  padding: 0 40px;
}
.formbuilder-sidebar-editor .sidebar-header h2 {
  margin: 0;
  text-align: center;
  text-align: center;
  font-size: 33px;
  color: #464d5d;
  font-weight: 400;
  line-height: 35px;
  text-rendering: optimizelegibility;
}
</style>
